import { UserModel } from '../model/general.model';

export const userOptionLabel = (user: UserModel): string => {
  if (!user) {
    return '';
  }

  return `${user.firstName} ${user.lastName}` + (user.department ? ` (${user.department})` : '');
}

export const sortUsers = (users: UserModel[]): UserModel[] => {
  return users.sort((a, b) => {
    let cmp = (a.department ?? '').localeCompare(b.department ?? '');
    return cmp  ||  a.lastName.localeCompare(b.lastName);
  });
}

